export default __webpack_public_path__ + "assets/json/cc2ebe34161a166801901f2bd5661540.json";